export const undoLastEdit = (
  e,
  setToggleClearSF,
  currentEdits,
  undoList,
  setQSValues,
  setQSData,
  setShowcalculator,
  setUndoFocusFlag,
  loadedQSValues,
  loadedQSData,
  setEditID,
  setPpaymentterm,
  setPpaymenttermData,
  ppaymenttermUSQS,
  ppaymenttermDataUSQS,
  loadedPpayterm,
  loadedPpaytermData,
  setSpaymentterm,
  setSpaymenttermData,
  spaymenttermUSQS,
  spaymenttermDataUSQS,
  loadedSpayterm,
  loadedSpaytermData,
  setNavpostoedit
) => {
  // Executes when pressing Ctrl+z. Behavior attached via AddEventListener
  e.preventDefault(); // Prevent the default browser undo behavior
  // Get the currently focused input field
  const activeInput = document.activeElement;
  // Check if the focused input field has a value then esc the input and exit.
  if (activeInput && activeInput.value) {
    setToggleClearSF((prev) => !prev);
  }
  const numtypes = ["decimal", "percent", "currency", "integer", "radio", "text"];
  let lookedUpEdits = [];
  let removedEdits = [];
  // Check if currentEdits is not empty
  if (currentEdits.current.length > 0) {
    // Find the highest editID in currentEdits
    const maxEditID = Math.max(...currentEdits.current.map((edit) => edit.editID));
    // Remove all elements with the highest editID from currentEdits and push them into undoList
    removedEdits = currentEdits.current.filter((edit) => edit.editID === maxEditID);
    currentEdits.current = currentEdits.current.filter((edit) => edit.editID !== maxEditID);
    undoList.current.push(...removedEdits);
    // // Look up the next highest editID for the removed field names
    lookedUpEdits = removedEdits.map((removedEdit) => {
      const matchingEdits = currentEdits.current.filter((edit) => edit.name === removedEdit.name); // Match the field name
      if (matchingEdits.length === 0) {
        return null; // No matching edits found
      }
      // Find the highest editID among the matching edits
      return matchingEdits.reduce((prev, curr) => (prev.editID > curr.editID ? prev : curr));
    });
    // Update the USposition and USpositionData state with the looked-up edits
    lookedUpEdits.forEach((edit) => {
      if (edit) {
        // console.log(edit);
        if (numtypes.includes(edit.figuretype)) {
          setQSValues((prev) => ({
            ...prev,
            [edit.name]: edit.value,
          }));
          setQSData((prev) => ({
            ...prev,
            [edit.name]: edit.num,
          }));
        } else if (edit.figuretype === "portion" || edit.figuretype === "termdays") {
          if (edit.origin === "purchase") {
            setPpaymentterm((prev) =>
              prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
            );
            setPpaymenttermData((prev) =>
              prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.num } : item))
            );
          }
          if (edit.origin === "sales") {
            setSpaymentterm((prev) =>
              prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
            );
            setSpaymenttermData((prev) =>
              prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.num } : item))
            );
          }
        } else if (edit.figuretype === "payType") {
          if (edit.origin === "purchase") {
            setPpaymentterm((prev) =>
              prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
            );
            setPpaymenttermData((prev) =>
              prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype + "ID"]: edit.num } : item))
            );
          }
          if (edit.origin === "sales") {
            setSpaymentterm((prev) =>
              prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
            );
            setSpaymenttermData((prev) =>
              prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype + "ID"]: edit.num } : item))
            );
          }
          setToggleClearSF((prev) => !prev);
        } else if (edit.figuretype === "delpayrow") {
          if (edit.origin === "purchase") {
            let temp5 = edit.temp;
            let temp6 = edit.tempData;
            setPpaymentterm((prev) => [...prev.slice(0, edit.ind), temp5, ...prev.slice(edit.ind, prev.length)]);
            setPpaymenttermData((prev) => [...prev.slice(0, edit.ind), temp6, ...prev.slice(edit.ind, prev.length)]);
          }
          if (edit.origin === "sales") {
            let temp5 = edit.temp;
            let temp6 = edit.tempData;
            setSpaymentterm((prev) => [...prev.slice(0, edit.ind), temp5, ...prev.slice(edit.ind, prev.length)]);
            setSpaymenttermData((prev) => [...prev.slice(0, edit.ind), temp6, ...prev.slice(edit.ind, prev.length)]);
          }
        } else if (edit.figuretype === "posloadedtoqs") {
          setNavpostoedit(edit.num);
        } else if (edit.figuretype === "ptermsfrompos") {
          setPpaymentterm(edit.vals);
          setPpaymenttermData(edit.data);
        } else {
          setQSValues((prev) => ({
            ...prev,
            [edit.name]: edit.value,
          }));
          setQSData((prev) => ({
            ...prev,
            [edit.nameID]: edit.valueID,
          }));
        }
      }
    });
    // If input element is part of a calculator module, then setShowcalculator to make the calculator visible
    const outboundvars = ["outdrayage", "loading", "outcollectcharges", "outboundothers", "outpayload"];
    const oceanfrvars = ["oceanpayload", "oceanfreight"];
    const importcustomvars = [
      "generaldutyimp",
      "additionaldutyimp",
      "harborfeepct",
      "merchprocfeepct",
      "flatfee",
      "tsca",
      "isf",
    ];
    const inboundvars = ["inpayload", "indrayage", "unloading", "incollectcharges", "inboundothers"];
    const insurvars = ["insurancerate", "insurancefactor"];
    if (outboundvars.includes(lookedUpEdits[0]?.name)) {
      setShowcalculator("outboundcost");
    } else if (oceanfrvars.includes(lookedUpEdits[0]?.name)) {
      setShowcalculator("oceanfreight");
    } else if (importcustomvars.includes(lookedUpEdits[0]?.name)) {
      setShowcalculator("importcustomsfee");
    } else if (inboundvars.includes(lookedUpEdits[0]?.name)) {
      setShowcalculator("inboundcost");
    } else if (insurvars.includes(lookedUpEdits[0]?.name)) {
      setShowcalculator("insurance");
    } else {
      setShowcalculator("");
    }
    // Focus the input field of the first lookedup edit
    if (numtypes.includes(lookedUpEdits[0]?.figuretype)) {
      setUndoFocusFlag(lookedUpEdits[0]?.name);
    } else if (
      lookedUpEdits[0]?.figuretype === "portion" ||
      lookedUpEdits[0]?.figuretype === "termdays" ||
      removedEdits[0]?.figuretype === "payType"
    ) {
      setUndoFocusFlag(lookedUpEdits[0]?.name);
    } else {
      setUndoFocusFlag(lookedUpEdits[0]?.nameID);
    }
    // If no previous edit found for any of the removed edits, reset to unedited value from initial load state
    if (lookedUpEdits.filter((edit) => edit !== null).length === 0) {
      removedEdits.forEach((re) => {
        if (re) {
          if (numtypes.includes(re.figuretype)) {
            setQSValues((prev) => ({
              ...prev,
              [re.name]: loadedQSValues.current ? loadedQSValues.current[re.name] : "",
            }));
            setQSData((prev) => ({
              ...prev,
              [re.name]: loadedQSData.current ? loadedQSData.current[re.name] : "",
            }));
          } else if (re.figuretype === "portion" || re.figuretype === "termdays") {
            if (re.origin === "purchase") {
              setPpaymentterm((prev) =>
                prev.map((item) => {
                  if (item.row === re.row) {
                    const match = loadedPpayterm.current.find((d) => d.row === re.row);
                    return match ? { ...item, [re.figuretype]: match[re.figuretype] } : item;
                  }
                  return item;
                })
              );
              setPpaymenttermData((prev) =>
                prev.map((item) => {
                  if (item.row === re.row) {
                    const match = loadedPpaytermData.current.find((d) => d.row === re.row);
                    return match ? { ...item, [re.figuretype]: match[re.figuretype] } : item;
                  }
                  return item;
                })
              );
            }
            if (re.origin === "sales") {
              setSpaymentterm((prev) =>
                prev.map((item) => {
                  if (item.row === re.row) {
                    const match = loadedSpayterm.current.find((d) => d.row === re.row);
                    return match ? { ...item, [re.figuretype]: match[re.figuretype] } : item;
                  }
                  return item;
                })
              );
              setPpaymenttermData((prev) =>
                prev.map((item) => {
                  if (item.row === re.row) {
                    const match = loadedSpaytermData.current.find((d) => d.row === re.row);
                    return match ? { ...item, [re.figuretype]: match[re.figuretype] } : item;
                  }
                  return item;
                })
              );
            }
          } else if (re.figuretype === "payType") {
            if (re.origin === "purchase") {
              setPpaymentterm((prev) =>
                prev.map((item) => {
                  if (item.row === re.row) {
                    const match = loadedPpayterm.current.find((d) => d.row === re.row);
                    return match ? { ...item, [re.figuretype]: match[re.figuretype] } : item;
                  }
                  return item;
                })
              );
              setPpaymenttermData((prev) =>
                prev.map((item) => {
                  if (item.row === re.row) {
                    const match = loadedPpaytermData.current.find((d) => d.row === re.row);
                    return match ? { ...item, [re.figuretype + "ID"]: match[re.figuretype + "ID"] } : item;
                  }
                  return item;
                })
              );
            }
            if (re.origin === "sales") {
              setSpaymentterm((prev) =>
                prev.map((item) => {
                  if (item.row === re.row) {
                    const match = loadedSpayterm.current.find((d) => d.row === re.row);
                    return match ? { ...item, [re.figuretype]: match[re.figuretype] } : item;
                  }
                  return item;
                })
              );
              setSpaymenttermData((prev) =>
                prev.map((item) => {
                  if (item.row === re.row) {
                    const match = loadedSpaytermData.current.find((d) => d.row === re.row);
                    return match ? { ...item, [re.figuretype + "ID"]: match[re.figuretype + "ID"] } : item;
                  }
                  return item;
                })
              );
            }
            setToggleClearSF((prev) => !prev);
          } else if (re.figuretype === "delpayrow") {
            if (re.origin === "purchase") {
              setPpaymentterm((prev) => [...prev.slice(0, re.ind), re.temp, ...prev.slice(re.ind, prev.length)]);
              setPpaymenttermData((prev) => [
                ...prev.slice(0, re.ind),
                re.tempData,
                ...prev.slice(re.ind, prev.length),
              ]);
            }
            if (re.origin === "sales") {
              setSpaymentterm((prev) => [...prev.slice(0, re.ind), re.temp, ...prev.slice(re.ind, prev.length)]);
              setSpaymenttermData((prev) => [
                ...prev.slice(0, re.ind),
                re.tempData,
                ...prev.slice(re.ind, prev.length),
              ]);
            }
          } else if (re.figuretype === "addpayrow") {
            if (re.origin === "purchase") {
              setPpaymentterm((prev) => prev.filter((item) => item.row !== re.row));
              setPpaymenttermData((prev) => prev.filter((item) => item.row !== re.row));
            }
            if (re.origin === "sales") {
              setSpaymentterm((prev) => prev.filter((item) => item.row !== re.row));
              setSpaymenttermData((prev) => prev.filter((item) => item.row !== re.row));
            }
          } else if (re.figuretype === "posloadedtoqs") {
            setNavpostoedit("");
          } else if (re.figuretype === "ptermsfrompos") {
            setPpaymentterm(loadedPpayterm.current);
            setPpaymenttermData(loadedPpaytermData.current);
          } else {
            setQSValues((prev) => ({
              ...prev,
              [re.name]: loadedQSValues.current ? loadedQSValues.current[re.name] : "",
            }));
            setQSData((prev) => ({
              ...prev,
              [re.nameID]: loadedQSData.current ? loadedQSData.current[re.nameID] : "",
            }));
          }
        }
      });

      if (outboundvars.includes(removedEdits[0]?.name)) {
        setShowcalculator("outboundcost");
      } else if (oceanfrvars.includes(removedEdits[0]?.name)) {
        setShowcalculator("oceanfreight");
      } else if (importcustomvars.includes(removedEdits[0]?.name)) {
        setShowcalculator("importcustomsfee");
      } else if (inboundvars.includes(removedEdits[0]?.name)) {
        setShowcalculator("inboundcost");
      } else if (insurvars.includes(removedEdits[0]?.name)) {
        setShowcalculator("insurance");
      } else {
        setShowcalculator("");
      }
      // Focus the input field of the first removed edit
      if (numtypes.includes(removedEdits[0]?.figuretype)) {
        setUndoFocusFlag(removedEdits[0]?.name);
      } else if (
        removedEdits[0]?.figuretype === "portion" ||
        removedEdits[0]?.figuretype === "termdays" ||
        removedEdits[0]?.figuretype === "payType"
      ) {
        // console.log("name", removedEdits[0]?.name);

        setUndoFocusFlag(removedEdits[0]?.name);
      } else {
        setUndoFocusFlag(removedEdits[0]?.nameID);
      }
    }
  } else {
    setShowcalculator("");
  }
  // Update the editID state
  setEditID((prev) => (prev > 0 ? prev - 1 : 0));
};

export const redoLastEdit = (
  e,
  setToggleClearSF,
  undoList,
  currentEdits,
  setQSValues,
  setQSData,
  setShowcalculator,
  setUndoFocusFlag,
  setEditID,
  setPpaymentterm,
  setPpaymenttermData,
  loadedPpayterm,
  loadedPpaytermData,
  setSpaymentterm,
  setSpaymenttermData,
  loadedSpayterm,
  loadedSpaytermData,
  setNavpostoedit
) => {
  e.preventDefault();
  // Get the currently focused input field
  const activeInput = document.activeElement;
  // Check if the focused input field has a value then esc the input and exit.
  if (activeInput && activeInput.value) {
    setToggleClearSF((prev) => !prev);
  }
  // Check if undoList is not empty
  if (undoList.current.length > 0) {
    // Find the lowest editID in undoList
    const minEditID = Math.min(...undoList.current.map((edit) => edit.editID));
    let redoEdits = [];
    // Remove all elements with the lowest EditID from undoList and push them into positionEdits
    redoEdits = undoList.current.filter((edit) => edit.editID === minEditID);
    undoList.current = undoList.current.filter((edit) => edit.editID !== minEditID);
    currentEdits.current.push(...redoEdits);

    const numtypes = ["decimal", "percent", "currency", "integer", "radio", "text"];
    // Set USposition and USpositionData to the values of the redoEdits
    redoEdits.forEach((edit) => {
      if (numtypes.includes(edit.figuretype)) {
        // Update USposition and USpositionData state
        setQSValues((prev) => ({
          ...prev,
          [edit.name]: edit.value,
        }));
        setQSData((prev) => ({
          ...prev,
          [edit.name]: edit.num,
        }));
      } else if (edit.figuretype === "portion" || edit.figuretype === "termdays") {
        if (edit.origin === "purchase") {
          setPpaymentterm((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
          );
          setPpaymenttermData((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.num } : item))
          );
        }
        if (edit.origin === "sales") {
          setSpaymentterm((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
          );
          setSpaymenttermData((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.num } : item))
          );
        }
      } else if (edit.figuretype === "payType") {
        if (edit.origin === "purchase") {
          setPpaymentterm((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
          );
          setPpaymenttermData((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype + "ID"]: edit.num } : item))
          );
        }
        if (edit.origin === "sales") {
          setSpaymentterm((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype]: edit.value } : item))
          );
          setSpaymenttermData((prev) =>
            prev.map((item) => (item.row === edit.row ? { ...item, [edit.figuretype + "ID"]: edit.num } : item))
          );
        }
        setToggleClearSF((prev) => !prev);
      } else if (edit.figuretype === "delpayrow") {
        if (edit.origin === "purchase") {
          setPpaymentterm((prev) => prev.filter((item) => item.row !== edit.row));
          setPpaymenttermData((prev) => prev.filter((item) => item.row !== edit.row));
        }
        if (edit.origin === "sales") {
          setSpaymentterm((prev) => prev.filter((item) => item.row !== edit.row));
          setSpaymenttermData((prev) => prev.filter((item) => item.row !== edit.row));
        }
      } else if (edit.figuretype === "addpayrow") {
        if (edit.origin === "purchase") {
          setPpaymentterm((prev) => [
            ...prev,
            { row: edit.row, portion: "0.00%", payType: "CAD", termdays: "10", type: "new" },
          ]);
          setPpaymenttermData((prev) => [
            ...prev,
            { row: edit.row, portion: 0, payTypeID: 1, termdays: 10, type: "new" },
          ]);
        }
        if (edit.origin === "sales") {
          setSpaymentterm((prev) => [
            ...prev,
            { row: edit.row, portion: "0.00%", payType: "CAD", termdays: "10", type: "new" },
          ]);
          setSpaymenttermData((prev) => [
            ...prev,
            { row: edit.row, portion: 0, payTypeID: 1, termdays: 10, type: "new" },
          ]);
        }
      } else if (edit.figuretype === "posloadedtoqs") {
        setNavpostoedit(edit.num);
      } else if (edit.figuretype === "ptermsfrompos") {
        setPpaymentterm(edit.vals);
        setPpaymenttermData(edit.data);
      } else {
        // Update USposition and USpositionData state
        setQSValues((prev) => ({
          ...prev,
          [edit.name]: edit.value,
        }));
        setQSData((prev) => ({
          ...prev,
          [edit.nameID]: edit.valueID,
        }));
      }
    });
    const outboundvars = ["outdrayage", "loading", "outcollectcharges", "outboundothers", "outpayload"];
    const oceanfrvars = ["oceanpayload", "oceanfreight"];
    const importcustomvars = [
      "generaldutyimp",
      "additionaldutyimp",
      "harborfeepct",
      "merchprocfeepct",
      "flatfee",
      "tsca",
      "isf",
    ];
    const inboundvars = ["inpayload", "indrayage", "unloading", "incollectcharges", "inboundothers"];
    const insurvars = ["insurancerate", "insurancefactor"];

    if (outboundvars.includes(redoEdits[0]?.name)) {
      setShowcalculator("outboundcost");
    } else if (oceanfrvars.includes(redoEdits[0]?.name)) {
      setShowcalculator("oceanfreight");
    } else if (importcustomvars.includes(redoEdits[0]?.name)) {
      setShowcalculator("importcustomsfee");
    } else if (inboundvars.includes(redoEdits[0]?.name)) {
      setShowcalculator("inboundcost");
    } else if (insurvars.includes(redoEdits[0]?.name)) {
      setShowcalculator("insurance");
    } else {
      setShowcalculator("");
    }
    // Focus the input field of the first removed edit
    if (numtypes.includes(redoEdits[0]?.figuretype)) {
      setUndoFocusFlag(redoEdits[0]?.name);
    } else if (
      redoEdits[0]?.figuretype === "portion" ||
      redoEdits[0]?.figuretype === "termdays" ||
      redoEdits[0]?.figuretype === "payType"
    ) {
      // console.log("name", redoEdits[0]?.name);
      setUndoFocusFlag(redoEdits[0]?.name);
    } else {
      setUndoFocusFlag(redoEdits[0]?.nameID);
    }
  }
  setEditID((prev) => prev + 1);
  // console.log(currentEdits.current);
};
